import { normalizeReferralCode } from './config'

export const REFERRAL_STORAGE_KEY = 'wgis_ref'

const NINETY_DAYS = 60 * 60 * 24 * 90

function canUseBrowserStorage(): boolean {
  return typeof window !== 'undefined'
}

export function referralCodeFromCookie(cookie: string): string | null {
  const parts = cookie.split(';')
  for (const part of parts) {
    const [rawKey, ...rawValue] = part.trim().split('=')
    if (rawKey !== REFERRAL_STORAGE_KEY) continue
    try {
      return normalizeReferralCode(decodeURIComponent(rawValue.join('=')))
    } catch {
      return normalizeReferralCode(rawValue.join('='))
    }
  }
  return null
}

export function storeReferralCode(rawCode: string | null | undefined): string | null {
  const code = normalizeReferralCode(rawCode)
  if (!code || !canUseBrowserStorage()) return code

  try {
    window.localStorage.setItem(REFERRAL_STORAGE_KEY, code)
  } catch {
    // Private mode or blocked storage. Cookie fallback may still work.
  }

  try {
    document.cookie = `${REFERRAL_STORAGE_KEY}=${encodeURIComponent(code)}; path=/; max-age=${NINETY_DAYS}; samesite=lax`
  } catch {
    // Best-effort attribution only.
  }

  return code
}

export function readStoredReferralCode(): string | null {
  if (!canUseBrowserStorage()) return null

  try {
    const code = normalizeReferralCode(window.localStorage.getItem(REFERRAL_STORAGE_KEY))
    if (code) return code
  } catch {
    // Fall through to the cookie fallback.
  }

  try {
    return referralCodeFromCookie(document.cookie)
  } catch {
    return null
  }
}

export function clearStoredReferralCode(): void {
  if (!canUseBrowserStorage()) return

  try {
    window.localStorage.removeItem(REFERRAL_STORAGE_KEY)
  } catch {
    // Ignore blocked storage.
  }

  try {
    document.cookie = `${REFERRAL_STORAGE_KEY}=; path=/; max-age=0; samesite=lax`
  } catch {
    // Ignore blocked cookies.
  }
}
